export class TypeBuilder {
    defaultValue;
    isDefaultConstant;
    def;
    _required;
    _readonly;
    constructor(def, required, readonly, defaultValue, isDefaultConstant) {
        this.defaultValue = defaultValue;
        this.isDefaultConstant = isDefaultConstant;
        this.def = def;
        this._required = required;
        this._readonly = readonly;
    }
    required() {
        return new TypeBuilder(this.def, true, this._readonly, this.defaultValue, this.isDefaultConstant);
    }
    readonly() {
        return new TypeBuilder(this.def, this._required, true, this.defaultValue, this.isDefaultConstant);
    }
    nullable() {
        return OrType([this, NullType]);
    }
    or(b) {
        return OrType([this, b]);
    }
    default(defaultValue) {
        if (this.hasDefault()) {
            throw new Error("This type already has a default value", {
                cause: this,
            });
        }
        return new TypeBuilder(this.def, this._required, this._readonly, () => defaultValue, true);
    }
    defaultGenerated(defaultValue) {
        if (this.hasDefault()) {
            throw new Error("This type already has a default value", {
                cause: this,
            });
        }
        return new TypeBuilder(this.def, this._required, this._readonly, defaultValue, false);
    }
    hasDefault() {
        return this.defaultValue !== undefined;
    }
}
export const InitTypeBuilder = (def) => new TypeBuilder(def, false, false, undefined, false);
const StaticType = (name) => {
    return InitTypeBuilder({
        type: name,
        output: undefined,
        init: undefined,
    });
};
export const AnyType = StaticType("any");
export const UnknownType = StaticType("unknown");
export const UndefinedType = StaticType("undefined");
export const NullType = StaticType("null");
export const BooleanType = StaticType("boolean");
export const NumberType = StaticType("number");
export const StringType = StaticType("string");
export const DateType = StaticType("Date");
export const ArrayType = (element) => InitTypeBuilder({
    type: "array",
    element,
    output: [],
    init: [],
});
export const RecordType = (element) => InitTypeBuilder({
    type: "record",
    element,
    output: {},
    init: {},
});
export const ObjectType = (shape) => InitTypeBuilder({
    type: "object",
    shape,
    output: {},
    init: {},
});
export const OrType = (types) => InitTypeBuilder({
    type: "or",
    types,
    output: undefined,
    init: undefined,
});
//# sourceMappingURL=types.js.map